import React, { Suspense } from "react";
import { HashRouter, Route, Routes } from 'react-router-dom';
import routes from "../route";
import { AuthProvider } from "../Context";
import Events from "../../views/operation/Event";

function DefaultLayout() {
    return (
        <Suspense fallback={<div>Loading...</div>}>

            <AuthProvider>
                <Routes>
                    <Route path="/">
                        <Route index element={<Events />} />
                        {routes.map((route, idx) =>
                            <Route key={`menu_${Math.random()}`} path={route.path} element={<route.component />} />)}
                    </Route>
                </Routes>
            </AuthProvider>

        </Suspense>
    );
}

export default DefaultLayout;
